import { LOADING_TYPES } from "./constants";

export const PROGRESS_MODE = {
  INDETERMINATE: "indeterminate",
  DETERMINATE: "determinate",
};

/** Types that default to indeterminate unless a total is supplied. */
const INDETERMINATE_BY_DEFAULT = new Set([
  LOADING_TYPES.DEFAULT,
  LOADING_TYPES.NAVIGATION,
  LOADING_TYPES.FIRESTORE,
  LOADING_TYPES.AUTH,
]);

/** Types that default to determinate when total is known. */
const DETERMINATE_WHEN_TOTAL = new Set([
  LOADING_TYPES.UPLOAD,
  LOADING_TYPES.IMPORT,
  LOADING_TYPES.EXPORT,
  LOADING_TYPES.BATCH,
  LOADING_TYPES.REPORT,
]);

/**
 * Pick progress UI mode from operation options.
 * @param {{ type?: string, mode?: string, total?: number, determinate?: boolean, indeterminate?: boolean }} options
 */
export function resolveProgressMode(options = {}) {
  if (options.mode === PROGRESS_MODE.DETERMINATE || options.mode === PROGRESS_MODE.INDETERMINATE) {
    return options.mode;
  }
  if (options.determinate === true) return PROGRESS_MODE.DETERMINATE;
  if (options.indeterminate === true) return PROGRESS_MODE.INDETERMINATE;

  const hasTotal = Number(options.total) > 0;
  const type = options.type || LOADING_TYPES.DEFAULT;

  if (hasTotal) return PROGRESS_MODE.DETERMINATE;

  if (DETERMINATE_WHEN_TOTAL.has(type)) {
    return PROGRESS_MODE.INDETERMINATE;
  }
  if (INDETERMINATE_BY_DEFAULT.has(type)) {
    return PROGRESS_MODE.INDETERMINATE;
  }

  return PROGRESS_MODE.INDETERMINATE;
}

export function formatProgressLabel(current, total, unit = "") {
  const c = Number(current) || 0;
  const t = Number(total) || 0;
  if (t <= 0) return "";
  const suffix = unit ? ` ${unit}` : "";
  return `${c.toLocaleString("en-IN")} / ${t.toLocaleString("en-IN")}${suffix}`;
}

export function formatProgressPercent(current, total) {
  const t = Number(total) || 0;
  if (t <= 0) return null;
  const c = Math.max(0, Number(current) || 0);
  return Math.min(100, Math.round((c / t) * 100));
}
